import { Button } from 'components/ui/Button'
import { useTranslation } from 'react-i18next'
import { NsKey } from 'enums/NsKey'
import { Sizes } from 'enums/sizes'
import { TrashIcon } from 'components/icons/Icons'
import clsx from 'clsx'

export interface DialogFooterProps {
  onClose: () => void
  isLoading?: boolean
  onSubmit: () => void
  closeLabel?: string
  submitDisabled?: boolean
  submitLabel: string
  onDelete?: () => void
  deleteLabel?: string
  deleteDisabled?: boolean
  className?: string
}

const DialogFooter: React.FC<DialogFooterProps> = ({
  onClose,
  onSubmit,
  submitLabel,
  submitDisabled,
  closeLabel,
  onDelete,
  deleteLabel,
  deleteDisabled,
  isLoading = false,
  className
}) => {
  const { t } = useTranslation(NsKey.Common)

  return (
    <div className={clsx(
      "mt-8 flex items-center justify-between gap-3",
      className
    )}>
      <div className="flex items-center">
        {onDelete && (
          <Button color="slate" round onClick={onDelete} disabled={deleteDisabled || isLoading}>
            <TrashIcon />
            {deleteLabel && t(deleteLabel)}
          </Button>
        )}
      </div>
      <div className="flex flex-col-reverse items-center gap-3 *:w-full sm:flex-row sm:*:w-auto">
        {closeLabel && (
          <Button
            size={Sizes.lg}
            outline
            disabled={isLoading}
            onClick={onClose}
          >
            {t(closeLabel)}
          </Button>
        )}
        <Button
          color="secondary"
          type="submit"
          size={Sizes.lg}
          disabled={submitDisabled || isLoading}
          onClick={() => onSubmit()}
        >
          {t(submitLabel)}
        </Button>
      </div>
    </div>
  )
}

export default DialogFooter
